import React, { useState, useEffect } from 'react';
import { FiRefreshCw, FiCheckCircle, FiXCircle, FiAlertTriangle } from 'react-icons/fi';
import api from '../services/AxiosService';

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadReports = async () => {
    setLoading(true);
    try {
      const res = await api.get('/reports');
      const list = Array.isArray(res) ? res : (res.reports || res.data || []);
      setReports(list);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadReports(); }, []);

  const handleResolve = async (id, action) => {
    try {
      await api.patch(`/reports/${id}`, { status: action });
      loadReports();
    } catch (err) { alert('Failed to update report'); }
  };

  return (
    <div className="space-y-5 max-w-6xl text-left">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 bg-white border border-slate-200 p-6 rounded-2xl shadow-sm">
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">Reports & Moderation</h1>
          <p className="text-xs font-medium text-slate-500 mt-1">{reports.length} total user reports submitted</p>
        </div>
        <button onClick={loadReports} className="p-2.5 rounded-xl bg-slate-100 text-slate-600 hover:text-slate-900 hover:bg-slate-200 transition shadow-sm" title="Refresh"><FiRefreshCw className="w-4 h-4" /></button>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-7 h-7 border-2 border-purple-600/30 border-t-purple-600 rounded-full animate-spin" />
          </div>
        ) : reports.length === 0 ? (
          <div className="text-center py-20">
            <FiAlertTriangle className="w-12 h-12 text-slate-300 mx-auto mb-3" />
            <p className="text-sm font-bold text-slate-700">No reports found</p>
            <p className="text-xs text-slate-500 font-medium mt-1">All clear! No user reports to review.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-100/70">
                  <th className="px-4 py-3 text-left text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Reporter</th>
                  <th className="px-4 py-3 text-left text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Type</th>
                  <th className="px-4 py-3 text-left text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Reason</th>
                  <th className="px-4 py-3 text-left text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Status</th>
                  <th className="px-4 py-3 text-left text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Date</th>
                  <th className="px-4 py-3 text-right text-[11px] font-extrabold text-slate-600 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {reports.map((r) => (
                  <tr key={r._id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-3.5 text-xs text-slate-900 font-bold">{r.reporterId?.name || r.reporterId?.username || '-'}</td>
                    <td className="px-4 py-3.5 text-xs font-semibold text-slate-700">{r.type || r.reportType || '-'}</td>
                    <td className="px-4 py-3.5 text-xs text-slate-600 font-medium max-w-[200px] truncate">{r.reason || r.description || '-'}</td>
                    <td className="px-4 py-3.5">
                      <span className={`px-2.5 py-1 rounded-lg text-[10px] font-extrabold border ${r.status === 'resolved' ? 'bg-emerald-50 text-emerald-800 border-emerald-200' : r.status === 'dismissed' ? 'bg-slate-100 text-slate-700 border-slate-200' : 'bg-amber-50 text-amber-800 border-amber-200'}`}>
                        {r.status || 'pending'}
                      </span>
                    </td>
                    <td className="px-4 py-3.5 text-xs text-slate-500 font-medium">{r.createdAt ? new Date(r.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '-'}</td>
                    <td className="px-4 py-3.5">
                      <div className="flex items-center justify-end gap-1.5">
                        {r.status !== 'resolved' && (
                          <button onClick={() => handleResolve(r._id, 'resolved')} className="p-1.5 rounded-lg text-slate-500 hover:text-emerald-700 hover:bg-emerald-50 transition" title="Resolve">
                            <FiCheckCircle className="w-3.5 h-3.5" />
                          </button>
                        )}
                        {r.status !== 'dismissed' && (
                          <button onClick={() => handleResolve(r._id, 'dismissed')} className="p-1.5 rounded-lg text-slate-500 hover:text-slate-700 hover:bg-slate-100 transition" title="Dismiss">
                            <FiXCircle className="w-3.5 h-3.5" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reports;
